/**
 * Constants for the Kubernetes Release Control plugin
 */
export const PLUGIN_ID = 'plugin.kubernetes-release.service';
export const PLUGIN_NAME = 'kubernetes-release';

export const API_ENDPOINTS = {
  RELEASES: '/releases',
  DEPLOY: '/deploy',
  CHANGES: '/changes',
} as const;

export const HTTP_HEADERS = {
  CONTENT_TYPE_JSON: 'application/json',
} as const;

export const HTTP_METHODS = {
  POST: 'POST',
  GET: 'GET',
} as const;

export const ERROR_MESSAGES = {
  FETCH_RELEASES: 'Error fetching releases',
  DEPLOY_RELEASE: 'Error deploying release',
  FETCH_CHANGES: 'Error fetching changes',
} as const;
